import { getQclAttributionContext } from './qclAttribution';

const DEFAULT_MARKETING_ORIGIN = 'https://www.quantchecklabs.com';

type BuildMarketingTrialUrlOptions = {
  ctaId: string;
  ctaLocation: string;
  sourcePage?: string;
  medium?: string;
  campaign?: string;
  includeResetOnboarding?: boolean;
  selectedPlan?: string;
};

const getMarketingOrigin = (): string => {
  const configured = (process.env.REACT_APP_MARKETING_SITE_ORIGIN || DEFAULT_MARKETING_ORIGIN).trim();
  return (configured || DEFAULT_MARKETING_ORIGIN).replace(/\/$/, '');
};

const getCurrentPagePath = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.location.pathname || undefined;
};

const setIfPresent = (params: URLSearchParams, key: string, value: string | null | undefined): void => {
  if (!value) {
    return;
  }

  params.set(key, value);
};

export const buildMarketingTrialUrl = ({
  ctaId,
  ctaLocation,
  sourcePage,
  medium = 'strategy_gate',
  campaign = 'free_trial_conversion',
  includeResetOnboarding = true,
  selectedPlan,
}: BuildMarketingTrialUrlOptions): string => {
  const url = new URL('/onboarding', getMarketingOrigin());
  if (includeResetOnboarding) {
    url.searchParams.set('resetOnboarding', '1');
  }
  url.searchParams.set('utm_source', 'platform');
  url.searchParams.set('utm_medium', medium);
  url.searchParams.set('utm_campaign', campaign);
  url.searchParams.set('trial_cta_id', ctaId);
  url.searchParams.set('trial_cta_location', ctaLocation);
  url.searchParams.set('trial_source_page', sourcePage || getCurrentPagePath() || 'platform');
  url.searchParams.set('trial_destination', '/onboarding');
  setIfPresent(url.searchParams, 'selected_plan', selectedPlan);

  const attribution = getQclAttributionContext();
  setIfPresent(url.searchParams, 'qcl_ref', attribution?.qclRef);
  setIfPresent(url.searchParams, 'qcl_cta', attribution?.qclCta);
  setIfPresent(url.searchParams, 'qcl_campaign_id', attribution?.qclCampaignId);
  setIfPresent(url.searchParams, 'qcl_partner_slug', attribution?.qclPartnerSlug);
  setIfPresent(url.searchParams, 'qcl_message_type', attribution?.qclMessageType);

  return url.toString();
};
